export default class ResetPasswordRequest {
    constructor(email = '', resetCode = '', newPassword) {
        this.email = email,
            this.resetCode = resetCode,
            this.newPassword = newPassword
    }
}